module.exports = __webpack_public_path__ + "./images/f2a1a8740ecaa4e9138bc4cab46edf08.webp";